<template>
  <div
    :class="[
      'UIElement',
      $style.Tabs
    ]"
  >
    <button
      v-for="tab in tabs"
      :key="tab.id"
      type="button"
      :class="[
        $style.Tab,
        selected === tab.id && $style.Tab__selected
      ]"
      @click="onChange(tab)"
      @mouseup="$event.currentTarget.blur()"
    >
      <div :class="$style.Tab_title">
        {{ tab.label }}
        <Badge
          v-if="tab.badge"
          :class="$style.Tab_badge"
          size="small"
        >{{ tab.badge }}</Badge>
      </div>
    </button>
  </div>
</template>

<script>
import {Badge} from '../Badge'

export default {
  components: {
    Badge
  },
  model: {
    prop: 'selected',
    event: 'change'
  },
  props: {
    /**
     * The selected tab ID.
     */
    selected: {
      type: String
    },
    /**
     * ```ts
     * interface Tab {
     *   id: string
     *   label: string
     *   badge?: string
     * }
     * ```
     */
    tabs: {
      type: Array,
      required: true
    }
  },
  methods: {
    onChange(tab) {
      /**
       * Emitted when the tab changes. The first argument is the tab ID and the
       * second argument is the selected tab object.
       *
       * @event change
       * @type {string, Tab}
       */
      this.$emit('change', tab.id, tab)
    }
  }
}
</script>

<style lang="scss" module>
@import "../../styles/variables";

.Tabs {
  display: flex;
  box-shadow: inset 0 -1px 0 #e0e3e9;
}

.Tab {
  appearance: none;
  // padding: 0 16px;
  padding: 0;
  border: none;
  background: none;
  font-size: inherit;

  &:active {
    outline: none;
  }

  &:focus {
    box-shadow:
      inset 0 0 2px 0 $focusColor,
      0 0 2px 0 $focusColor;
    outline: none;
  }

  &:hover .Tab_title {
    border-color: #dfe3e8;
    color: #212b36;
  }
}

.Tab_title {
  display: block;
  // min-width: 50px;
  // padding: 16px 0 13px;
  padding: 16px 16px 13px;
  border-bottom: 3px solid transparent;
  color: #637381;
  line-height: 20px;
  white-space: nowrap;
  cursor: pointer;

  .Tab__selected &, .Tab__selected:hover & {
    border-color: $focusColor;
    color: #212b36;
    cursor: default;
  }
}

.Tab_badge {
  position: relative;
  top: -1px;
  margin-left: 5px;
  line-height: 15px;
}
</style>
